import { createSlice } from "@reduxjs/toolkit";

// Ride-flow state lives in sessionStorage so a refresh mid-search doesn't
// wipe the user's pickup/dropoff, but it never outlives the tab.
const STORAGE_KEY = "mbzRideFlow";

const readStored = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const stored = readStored();

const initialState = {
  pickup: stored?.pickup ?? null,
  dropoff: stored?.dropoff ?? null,
  routeMeta: stored?.routeMeta ?? null, // { distance: "12.4 km", duration: "24 mins" }
  tier: stored?.tier ?? "Suzuki",
  notes: stored?.notes ?? "",
};

const persist = (state) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* private-mode quota — in-memory state still works */
  }
};

export const rideFlowSlice = createSlice({
  name: "rideFlow",
  initialState,
  reducers: {
    setPickup: (state, action) => {
      state.pickup = action.payload;
      state.routeMeta = null;
      persist(state);
    },
    setDropoff: (state, action) => {
      state.dropoff = action.payload;
      state.routeMeta = null;
      persist(state);
    },
    setRouteMeta: (state, action) => {
      state.routeMeta = action.payload;
      persist(state);
    },
    setTier: (state, action) => {
      state.tier = action.payload;
      persist(state);
    },
    setNotes: (state, action) => {
      state.notes = action.payload;
      persist(state);
    },
    resetRideFlow: (state) => {
      state.pickup = null;
      state.dropoff = null;
      state.routeMeta = null;
      state.tier = "Suzuki";
      state.notes = "";
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch { /* ignore */ }
    },
  },
});

export const { setPickup, setDropoff, setRouteMeta, setTier, setNotes, resetRideFlow } =
  rideFlowSlice.actions;

export default rideFlowSlice.reducer;
